/* eslint-disable */
import moment from 'moment';
import * as momentTz from 'moment-timezone';
import { Chip } from '@mui/material'
import { Tooltip } from "@gpstrackit/react-controls";

import Excellent from '../../assets/signalIcons/signal_excellent.svg';
import Good from '../../assets/signalIcons/signal_good.svg';
import Fair from '../../assets/signalIcons/signal_fair.svg';
import Poor from '../../assets/signalIcons/signal_poor.svg';
import Unknown from '../../assets/signalIcons/signal_unknown.svg';

//Notification
import {
	NotificationManager
} from "Components/Notifications";

import { endpoints } from 'Core/defaultValues';
import { get, toInteger } from 'lodash';
import { id } from 'date-fns/locale';

const backgroundColor = [
	'#66BB6A',
	'#03A9F4',
	'#1D2734',
	'#018F82',
	'#13B2A3',
	'#37AFCC',
	'#00C6FC',
	'#00ACFB',
	'#008CDD',
	'#0059A0',
	'#2F4F6C',
	'#6685A7',
	'#825C8D',
	'#812F6F',
	'#006014',
	'#007F25',
	'#40BE60',
	'#69C97D',
	'#A9EAB3',
	'#ECB651',
	'#EA6947',
	'#D13C3C',
	'#AC2A47',
	'#C23E68',
	'#E97694',
]

export const convertToKPH = (speedValue) => {
	let kph = 0;
	if (parseInt(speedValue) > 0) {
		kph = (speedValue * 1.609344);
	}
	return Math.ceil(kph);
}

export const parseUrl = (url) => {
	// delete the http or https to show an URL
	if (typeof url === 'string') {
		let newUrl = url.replace("https://", '');
		newUrl = newUrl.replace("http://", '')
		return newUrl;
	}
	return url;
}

export const isFacebookError = (error) => {
	// Error when the person does not allow the email in the Facebook authentication
	if (
		error &&
		error === "attributes required: [email]"
	) {
		return true
	}
	return false;
}

export const isAppleError = (error) => {
	// Error when the person does not allow the email in the Apple authentication
	if (
		error &&
		typeof error === "string" &&
		error.includes("privaterelay.appleid.com")
	) {
		return true
	}
	return false;
}

export const EmailNotFound = (error) => {
	if (typeof error === 'string' && error.includes('Sign in with Google')) {
		return true
	}
	return false;
}

export const ErrorHandlerLogin = (error, isPasswordError) => {
	let newError = error;

	if (newError) {
		// parse to string if the error is an object
		if (typeof newError == "object") {
			newError = newError.toString();
		}
		const errorMessageGraphql = 'Error: Graphql error: ';
		newError = newError.replace(new RegExp(errorMessageGraphql, "gi"), '');

		const errorMessagePrefix = 'Error: ';
		newError = newError.replace(new RegExp(errorMessageGraphql, "gi"), '');
		newError = newError.replace(new RegExp(errorMessagePrefix, "gi"), '');

		// implement language to message from cognito
		if (isPasswordError && newError.includes('Incorrect username or password.')) {
			return 'login_password_incorrect';
		}
		newError = newError.replace('ApolloUsername', 'Username')
		newError = newError.replace('ApolloError', 'Username')
		newError = newError.replace('Apollo', '')
		newError = newError.replace('CodeMismatchException: ', '')
		return newError.trim();
	}
	return error;
}

export const forTesting = () => {
	let isTesting = false;
	if (endpoints.ENVIRONMENT && (endpoints.ENVIRONMENT === "staging" || endpoints.ENVIRONMENT === "development")) {
		isTesting = true;
	}

	return isTesting;
}
export const OrderData = (list, key) => {

	let newSortList = [...list].sort((a, b) => {
		const itemA = String(a[key]).toUpperCase();
		const itemB = String(b[key]).toUpperCase();

		if (itemA < itemB) {
			return -1;
		}

		if (itemA > itemB) {
			return 1;
		}

		return 0;
	});

	return newSortList;
};

export const GetFormatForDate = (dateFormat) => {
	let format = 'MM/dd/yyyy';

	if (dateFormat === 'm/d/Y') {
		format = 'MM/dd/yyyy';
	} else if (dateFormat === 'd/m/Y') {
		format = 'dd/MM/yyyy';
	} else if (dateFormat === 'Y/m/d') {
		format = 'yyyy/MM/dd';
	}

	return format;
};

export const GetFormatForMoment = (dateFormat) => {
	let format = 'MM/DD/YYYY';

	if (dateFormat === 'm/d/Y') {
		format = 'MM/DD/YYYY';
	} else if (dateFormat === 'd/m/Y') {
		format = 'DD/MM/YYYY';
	} else if (dateFormat === 'Y/m/d') {
		format = 'YYYY/MM/DD';
	}

	return format;
};

export const GetNumberDaysBetweenTwoDates = (date1, date2) => {
	var differenceInTime = date2.getTime() - date1.getTime();
	return differenceInTime / (1000 * 3600 * 24);
};

export const validateEmail = (email) => {
	const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(String(email).toLowerCase());
};

export const MerginObjectArray = (originalArray, newArray, key = null) => {

	//***  merging array regarding its data */

	let merginObjectArray = originalArray
	newArray.map(element => {
		merginObjectArray = InsertIntoArray(merginObjectArray, element, key)
	})
	return merginObjectArray
}

export const InsertIntoArray = (arrayToInsert, data, key = null) => {

	//***  insert data in array checking if already exist */

	const index = key ? arrayToInsert.findIndex(element => element[key] === data[key]) :
		arrayToInsert.findIndex(element => element === data)

	if (index != -1) {
		arrayToInsert[index] = { ...arrayToInsert[index], ...data }
	}
	else {
		arrayToInsert.push(data)
	}

	return arrayToInsert
}

export const DayFormat = (value) => {
	let day
	switch (value) {
		case "monday":
			day = "MON"
			break;
		case "tuesday":
			day = "TUE"
			break;
		case "wednesday":
			day = "WED"
			break;
		case "thursday":
			day = "THU"
			break;
		case "friday":
			day = "FRI"
			break;
		case "saturday":
			day = "SAT"
			break;
		case "sunday":
			day = "SUN"
			break;
		default:
			break;
	}
	return day
}

export const formatCatalogAddress = (address) => {
	if (address && (address.address && address.zip && address.state || address.formatted)) {
		return `${address.formatted}` || `${address.address}, ${address.zip}, ${address.state}`;
	}
	return '';
};

export const formatCatalogDate = (unitTime, paramFormat = null) => {

	if (!unitTime) {
		return
	}

	const timeMoment = moment(unitTime);
	if (timeMoment.isValid()) {
		if (!paramFormat) {
			return `${timeMoment.format(GetFormatForMoment('m/d/Y') + ', h:mm a')} ${'(' + timeMoment.fromNow() + ')'}`
		} else {
			return `${timeMoment.format(paramFormat)} ${'(' + timeMoment.fromNow() + ')'}`
		}

	} else {
		//***  formatting integer timestamps to readable dates */

		let unixMoment

		if (unitTime && unitTime.length > 10) {
			unixMoment = moment.unix(Number(unitTime?.substring(0, unitTime.length - 3)))
		} else {
			unixMoment = moment.unix(Number(unitTime))
		}

		if (unixMoment.isValid()) {
			if (!paramFormat) {
				return `${unixMoment.format(GetFormatForMoment('m/d/Y') + ', h:mm a')} ${'(' + unixMoment.fromNow() + ')'}`
			} else {
				return `${unixMoment.format(paramFormat)} ${'(' + unixMoment.fromNow() + ')'}`
			}
		}

		//***  formatting integer timestamps to readable dates */			 
	}

	return

};

export const formatOffsetDisplayOdometer = (unit) => {

	const result = unit.useEcuOdometer ? Math.round(getValueFloat(unit?.ecuEngineOdometer) + getValueFloat(unit?.offsetEcuEngineOdometer))
		: Math.round(getValueFloat(unit?.engineOdometer) + getValueFloat(unit.offsetEngineOdometer))

	if (result !== null && result !== undefined)
		if (result < 0)
			return 0
		else
			return result

	return ''
}

export const formatOffsetDisplayEngineHours = (unit) => {
	const result = unit.useEcuEngineHours ? Math.round(getValueFloat(unit?.ecuEngineHours) + getValueFloat(unit?.offsetEcuEngineHours))
		: Math.round(getValueFloat(unit?.engineHours) + getValueFloat(unit?.offsetEngineHours))

	if (result !== null && result !== undefined)
		if (result < 0)
			return 0
		else
			return result

	return ''
}

export const getValueFloat = (value) => {
	return parseFloat(value || 0);
}

export const isJson = (str) => {
	try {
		JSON.parse(str);
	} catch (e) {
		return false;
	}
	return true;
}

export const round = (value, precision) => {
	var multiplier = Math.pow(10, precision || 0);
	return Math.round(value * multiplier) / multiplier;
}

export const createUUID = () => {
	const pattern = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
	return pattern.replace(/[xy]/g, (c) => {
		const r = (Math.random() * 16) | 0;
		const v = c === 'x' ? r : (r & 0x3) | 0x8;
		return v.toString(16);
	});
};


export const convertIntFromObjectToBoolean = (data) => {
	if (!data) {
		return null;
	}

	let newData = { ...data }
	Object.keys(data)?.forEach((key) => {
		let value = data[key];
		if (typeof value === "boolean") {
			newData = { ...newData, [key]: value ? 1 : 0 };
		}
	});

	return newData;
};

export const convertStringToIntegerBoolean = (value = '') => {
	let newValue = value.toString().toLowerCase() == 'on' ? 1 : 0;
	if (newValue == 0 && value != '' && !isNaN(value)) {
		return parseInt(value);
	} else if (newValue == 1) {
		return newValue;
	}

	return value;
};

export const getNetworkTypes = () => {
	let types = [
		{ id: "2G", name: "2G" },
		{ id: "3G", name: "3G" },
		{ id: "4G", name: "4G" },
		{ id: "5G", name: "5G" },
		{ id: "LTE", name: "LTE" }
	];
	return types;
}


export const copyToClipboard = (value, msg, msgTitle = "") => {

	if (!navigator.clipboard) {
		// use old commandExec() way
		const el = document.createElement('textarea');
		el.value = value;
		document.body.appendChild(el);
		el.select();

		document.execCommand('copy');

		document.body.removeChild(el);
		NotificationManager.success(msg, msgTitle, 3000, null, null, '', null);
	} else {
		navigator.clipboard.writeText(value).then(
			function () {
				NotificationManager.success(msg, msgTitle, 3000, null, null, '', null);
			})
			.catch(
				function () {
					//alert("err"); // error
				});
	}
}

/**
 * 
 * @param {*} date //date to be formatted 
 * @param {*} dateFrom //value to be formatted "date"(string), "long"(milisenconds)
 * @param {*} type //type of the format: date, datetime, time, age or custom 
 * @param {*} customFormat //custom format to format the date
 * @returns a date string formatted acording to the parameters entered
 */
export const getDateFormatted = (date, dateFrom, type, customFormat, timezone) => {
	let formatted = "";
	let dateToformat = "";

	if (dateFrom === "date") {
		dateToformat = timezone ? moment.utc(date) : moment(date)
	} else if (dateFrom === "long") {
		dateToformat = moment.unix(date / 1000);
	}

	if (timezone) {
		dateToformat = dateToformat.tz(timezone)
	}

	switch (type) {
		case "date":
			formatted = dateToformat.format("MMM DD YYYY " + (timezone ? "z" : ""))
			break;
		case "datetime":
			formatted = dateToformat.format("MMM DD YYYY h:mm:ss A " + (timezone ? "z" : ""))
			break;
		case "time":
			formatted = dateToformat.format("h:mm:ss A " + (timezone ? "z" : ""))
			break;
		case "age":
			formatted = dateToformat.fromNow()
			break;
		case "custom":
			formatted = !customFormat ? dateToformat.format("MMM DD YYYY h:mm:ss A " + (timezone ? "z" : "")) : dateToformat.format(customFormat + (timezone ? " z" : ""));
			break;
		default:
			formatted = date; // if the is no format return the same valew
			break;
	}


	let validationDate = new Date(date);
	if (isNaN(validationDate) && dateFrom === "date" && type === "datetime") {
		return ""
	}
	return formatted;
}

/**
 * 
 * @returns a list options with an amount of records with the structure [{id:"number",name:"number"}] from "5" to "500"
 * 
 */
export const getLastRecorsOptions = (limit) => {

	let lastRecordsOptions = [
		{ id: "5", name: "5" },
		{ id: "10", name: "10" },
		{ id: "20", name: "20" },
		{ id: "30", name: "30" },
		{ id: "50", name: "50" },
		{ id: "100", name: "100" },
		{ id: "200", name: "200" },
		{ id: "300", name: "300" },
		{ id: "500", name: "500" },
	];
	if (limit) lastRecordsOptions = lastRecordsOptions.filter(x => parseInt(x.id) <= limit)

	return lastRecordsOptions;
}

/**
 * Numbers validations for the ids on the search select feature
 * @param {*} obj 
 * @returns 
 */
export const idsValidation = (obj) => {
	if ('id' in obj && typeof (obj.id) === 'number' && !isNaN(obj.id)) {
		return true;
	} else {
		return false;
	}
}

export const detectBrowser = () => {
	// Return the current browser name
	if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1) {
		return 'Opera';
	} else if (navigator.userAgent.indexOf("Chrome") != -1) {
		return 'Chrome';
	} else if (navigator.userAgent.indexOf("Safari") != -1) {
		return 'Safari';
	} else if (navigator.userAgent.indexOf("Firefox") != -1) {
		return 'Firefox';
	} else if ((navigator.userAgent.indexOf("MSIE") != -1) || (!!document.documentMode == true)) {
		return 'IE';//crap
	} else {
		return 'Unknown';
	}
}


export const getQuery = (type) => {
	let querys = {
		'user-activitys-logs': `
			query searchAuditlogs ($accountId: String, $entity: EntityAuditLogInput, $action: [String], $opensearch: [String], $username: String, $dateRange: AWSDateTimeRange!, $nextToken: String, $lastRecords: Int) {
				result: searchAuditlogs (accountId: $accountId, entity: $entity, action: $action, opensearch: $opensearch, username: $username, dateRange: $dateRange, nextToken: $nextToken, lastRecords: $lastRecords) {
					items {
						id
						source
						urlReferrer
						module
						method
						ipAddress
						platform
						entityName
						entityId
						accountId
						action
						newValues
						parameters
						updatedBy
						updatedOn
						username
					}
					nextToken
				}
			}
		`,
		'activities-tab': ``,
		'raw-data': `
			query ($conditions: [DeviceReadingSearchInput], $sort: [DeviceReadingSortInput], $limit: Int, $offset: Int){
				result: searchDeviceReadings(conditions: $conditions sort: $sort limit: $limit offset: $offset) {
				total
				items {
					accountId
					id
					deviceId
					latitude
					longitude
					heading
					eventCode
					eventName
					address
					driverId
					driverName
					ecuEngineOdometer
					ecuSpeed
					ecuEngineHours
					engineHours
					ignitionStatus
					engineOdometer
					satelliteCount
					signal
					speed
					speedLimit
					unitTime
					state
					trail
					unitType
					zip
					hDop
					vDop
					deviceData
					distance
					
					createdAt
					updatedAt
					direction
					duration
					formattedAddress
					landmarkId
					sequenceNumber
					serverTime
					unitId
				}
				}
			} 
		`,
		'commands': `
			query ($searchBy: enumMessageOutboxSearchBy!, $entityName: enumEntityName, $entityId: String, $dateRange: AWSDateTimeRange, $limit: Int, $nextToken: String, $lastRecords: Int){
				result: searchMessageOutbox(searchBy: $searchBy, entityName: $entityName, entityId: $entityId, dateRange: $dateRange, limit: $limit, nextToken: $nextToken, lastRecords: $lastRecords) {
				items {
					to
					via
					message
					description
					status
					createdOn
					createdBy
				}
				nextToken
				}
			}
		`,
		'trouble-shooting-events-v1': `
			query ($accountId: String!, $deviceId: String!, $dateRange: AWSDateTimeRange!, $limit: Int, $conditions: [ TroubleshootingEventSearchInput ], $nextToken: String){
				result: searchTroubleshootingEvents(accountId: $accountId, deviceId: $deviceId, dateRange: $dateRange, limit: $limit, conditions: $conditions, nextToken: $nextToken) {
				items
				nextToken
				}
			}  
		`,
		'jira-summary': `
			query searchJiraSummary ($dateRange: AWSDateTimeRange!, $developer: String, $jiraTask: String) {
				result: searchJiraSummary (dateRange: $dateRange, developer: $developer, jiraTask: $jiraTask) {
					name
					country
					daysPeriod
					tasksPeriod
					taskPeriodGSD
                    taskPeriodOthers
					totalTimeHours
					totalTimeHoursGSD
                    totalTimeHoursOthers
					totalStoryPoints
					totalStoryPointsGSD
                    totalStoryPointsOthers
					totalRejectedTasks
					totalRejections
					kpi {
						quality
						estimation
						participation
						total
					}
				}
			}
		`,
		'default': ``,
		'scheduled-report': `
			query searchReportLogs ($accountId: String!, $dateRange: AWSDateTimeRange!, $openSearch: String, $limit: Int, $nextToken: String) {
				result: searchReportLogs (accountId: $accountId, dateRange: $dateRange, openSearch: $openSearch, limit: $limit, nextToken: $nextToken) {
					items {
						id
						createdOn
						scheduledAt
						scheduled
						scheduleId
						accountId
						reportName
						reportType
						completedOn
						emailsTo
						reportStatus
						argsPath
						dataResultPath
						format
						params
						outputUrl
						reportLogId
						sendByEmail
						lastProcessUpdate
						error
					}
					nextToken
				}
			}
		`,
		'report': `
			query executeReport ($id: Int!, $values: [ParamValue]!, $limit: Int, $nextToken: String) {
				executeReport (id: $id, values: $values, limit: $limit, nextToken: $nextToken){
					items
					nextToken
				}
			}
		`,
		'calamp-files': `
			query getCalampDeviceFiles ($esn: String!,$current: Boolean!) {
				result: getCalampDeviceFiles (esn: $esn, current: $current)
			}
		`,
		'edge-tensor': `query searchAiVideoReviews ($conditions: [AiVideoReviewSearchInput], $sort: [AiVideoReviewSortInput], $limit: Int, $offset: Int) {
                    result: searchAiVideoReviews (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                        items {
                            unitId
                            deviceId
                            rowId
                            accountId
                            unitTime
                            eventResult
                            eventName
                            status
                            resultEventNames
							deviceReading {
                                eventName
                                videoReview
								deviceData
                            }
                            createdOn
                            updatedOn
                        }
                    }
                }
		`
	}
	return querys[type || 'default'];
}

export const getBadget = (label, active, status, color, onClick) => {
	if (!status) {
		if (active) {
			return (
				<Chip
					label={label}
					size="small"
					style={{
						backgroundColor: color || "#00AAFB",
						color: "#ffffff"
					}}
					clickable={true}
					onClick={() => {
						onClick && onClick();
					}}
				/>

			);
		} else {
			return (
				<Chip
					label={label}
					disabled={!active}
					size="small"
					variant="outlined"
					clickable={true}
					onClick={() => {
						onClick && onClick();
					}}
				/>

			);
		}
	} else {
		switch (status) {
			case 'Complete':
			case 'Active':
				return (
					<div style={{ width: '100px', textAlign: 'center' }}>
						<Chip
							label={label}

							style={{
								backgroundColor: color || "#66BA6F",
								color: "#ffffff"
							}}
							clickable={true}
							onClick={() => {
								onClick && onClick();
							}}
						/>
					</div>
				);
			case 'Failed':
			case 'Expired':
				return (
					<div style={{ width: '100px', textAlign: 'center' }}>
						<Chip
							label={label}

							style={{
								backgroundColor: color || "#FF0000",
								color: "#ffffff"
							}}
							clickable={true}
							onClick={() => {
								onClick && onClick();
							}}
						/>
					</div>
				);
			case 'Pending':
				return (
					<div style={{ width: '100px', textAlign: 'center' }}>
						<Chip
							label={label}

							style={{
								backgroundColor: color || "#00AAFB",
								color: "#ffffff"
							}}
							clickable={true}
							onClick={() => {
								onClick && onClick();
							}}
						/>
					</div>
				);
			default:
				return (
					<div style={{ width: '100px', textAlign: 'center' }}>
						<Chip
							label={label}
							disabled={true}
							size="small"
							variant="outlined"
							clickable={true}
							onClick={() => {
								onClick && onClick();
							}}
						/>
					</div>
				);
		}
	}
}

export const getMinDateLimitBehaviour = (label, active) => {
	const MIN_DATE_LIMIT_BEHAVIOR = new Date("2011", "12", "01", "00", "00", "00", "00");

	return MIN_DATE_LIMIT_BEHAVIOR;
}


export const getPMUser = (userId, pmUsers) => {
	let user = userId;

	if (userId && userId?.startsWith("PM") && pmUsers && pmUsers?.length > 0) {
		let objUser = pmUsers.find(x => `PM_${x.id}` === userId);
		if (objUser) {
			user = `${objUser.firstName} ${objUser.lastName}`;
		}
	}
	return user;
}

export const getStatusOptions = (messages) => {
	const statusOptions = [
		{
			id: 1,
			label: messages['active']
		},
		{
			id: 4,
			label: messages['cancelled']
		},
		{
			id: 3,
			label: messages['involuntary_suspension']
		},
		{
			id: 2,
			label: messages['voluntary_suspension']
		},
		{
			id: 6,
			label: messages['rma']
		}
	]

	return statusOptions;
}

/********************************************************
 * Validate JSON
 ********************************************************/
export const isValidJson = (json) => {
	try {
		JSON.parse(json);
		return true;
	} catch (e) {
		return false;
	}
}

export const formatAddress = (element) => {
	let newAddress = element?.formattedAddress || '';
	if (!newAddress || newAddress == 'null') {
		if (element?.address && isValidJson(element?.address)) {
			const { formatted } = JSON.parse(element?.address)
			if (formatted) {
				newAddress = formatted || '';
			}
		} else {
			if (element?.address && element?.address?.formatted) {
				const { formatted } = element?.address
				newAddress = formatted
				return newAddress
			}
			newAddress = '';
		}
	}
	return newAddress
}

export const getTimezoneOffsetList = () => {
	let offsetList = [
		{ id: "-11:00", label: "GTM-11:00" },
		{ id: "-10:00", label: "GTM-10:00" },
		{ id: "-09:00", label: "GTM-09:00" },
		{ id: "-08:00", label: "GTM-08:00" },
		{ id: "-07:00", label: "GTM-07:00" },
		{ id: "-06:00", label: "GTM-06:00" },
		{ id: "-05:00", label: "GTM-05:00" },
		{ id: "-04:00", label: "GTM-04:00" },
		{ id: "-04:30", label: "GTM-04:30" },
		{ id: "-03:00", label: "GTM-03:00" },
		{ id: "-03:30", label: "GTM-03:30" },
		{ id: "-02:00", label: "GTM-02:00" },
		{ id: "-01:00", label: "GTM-01:00" },
		{ id: "+00:00", label: "GTM+00:00" },
		{ id: "+01:00", label: "GTM+01:00" },
		{ id: "+02:00", label: "GTM+02:00" },
		{ id: "+03:00", label: "GTM+03:00" },
		{ id: "+03:30", label: "GTM+03:30" },
		{ id: "+04:00", label: "GTM+04:00" },
		{ id: "+04:30", label: "GTM+04:30" },
		{ id: "+05:00", label: "GTM+05:00" },
		{ id: "+05:30", label: "GTM+05:30" },
		{ id: "+06:00", label: "GTM+06:00" },
		{ id: "+06:30", label: "GTM+06:30" },
		{ id: "+07:00", label: "GTM+07:00" },
		{ id: "+08:00", label: "GTM+08:00" },
		{ id: "+09:00", label: "GTM+09:00" },
		{ id: "+09:30", label: "GTM+09:30" },
		{ id: "+10:00", label: "GTM+10:00" },
		{ id: "+10:30", label: "GTM+10:30" },
		{ id: "+11:00", label: "GTM+11:00" },
		{ id: "+12:00", label: "GTM+12:00" },
		{ id: "+13:00", label: "GTM+13:00" },
		{ id: "+14:00", label: "GTM+14:00" },
	]

	return offsetList;
}

export const openLink = (link) => {
	if (link) {
		if (Array.isArray(link) && link.length > 1) {
			return [true, { urlsDownload: link }]
		} else {
			const newLink = Array.isArray(link) ? link[0]?.url : link
			const url = newLink.includes("http") ? newLink : `https://${newLink}`;
			const browser = detectBrowser();
			if (browser === 'Firefox' || browser === 'Safari') {
				window.open(url, '_blank')
			} else {
				let a = document.createElement("a");
				document.body.appendChild(a);
				a.style = "display: none";
				a.href = url;
				a.click();
				document.body.removeChild(a);
			}
			return [false, {}]
		}
	}
}


export const getUnitTypeDatabases = () => {
	let databases = [
		{ id: "APU_Wabtec", value: "APU_Wabtec" },
		{ id: "APU_Wabtec_L", value: "APU_Wabtec_L" },
		{ id: "APU_calamp", value: "APU_calamp" },
		{ id: "APU_calamp1100", value: "APU_calamp1100" },
		{ id: "APU_calampTT", value: "APU_calampTT" },
		{ id: "APU_history", value: "APU_history" },
		{ id: "APU_xirgoHW", value: "APU_xirgoHW" },
		{ id: "APU_xirgoPNP", value: "APU_xirgoPNP" },
		{ id: "APU_xirgoTT", value: "APU_xirgoTT" },
		{ id: "L2000A", value: "L2000A" },
		{ id: "L2000C", value: "L2000C" },
		{ id: "L2000C8", value: "L2000C8" },
		{ id: "L2000E", value: "L2000E" },
		{ id: "MotoAPU", value: "MotoAPU" },
		{ id: "Quantum", value: "Quantum" },
		{ id: "Sierra", value: "Sierra" },
		{ id: "Skywave", value: "Skywave" },
		{ id: "T1000", value: "T1000" },
		{ id: "T5000", value: "T5000" },
		{ id: "Webtech", value: "Webtech" },
		{ id: "Xirgo", value: "Xirgo" },
		{ id: "geometris", value: "geometris" },
		{ id: "numerex", value: "numerex" },
		{ id: "platformmanager", value: "platformmanager" },
		{ id: "pressurepro", value: "pressurepro" },
		{ id: "pui", value: "pui" },
		{ id: "queclink", value: "queclink" },
		{ id: "genx", value: "genx" },
	]

	return databases;
}

export const getNetworks = () => {
	let types = [
		{ id: "2G", name: "2G" },
		{ id: "3G", name: "3G" },
		{ id: "4G", name: "4G" },
		{ id: "N/A", name: "N/A" }
	];
	return types;
}

export const getSystems = () => {
	let types = [
		{ id: "CDMA", name: "CDMA" },
		{ id: "CDMA/SAT", name: "CDMA/SAT" },
		{ id: "GSM", name: "GSM" },
		{ id: "GSM/SAT", name: "GSM/SAT" },
		{ id: "LTE", name: "LTE" },
		{ id: "SAT", name: "SAT" },
		{ id: "N/A", name: "N/A" }
	];
	return types;
}

export const capitalizeFirstLetter = (str) => {
	return str.charAt(0).toUpperCase() + str.slice(1);
}
export const isBiggerFirmware = (first, second) => {
	let isBigger = false;

	if (first === "" && second === "")
		return false;
	else if (first === "" && second !== "")
		return false
	else if (first !== "" && second === "")
		return true;

	const firstData = first.split(".");
	const secondData = second.split(".");

	for (let index = 0; index < firstData.length - 1; index++) {
		if (firstData[index] !== secondData[index]) {
			if (firstData[index] > secondData[index]) {
				isBigger = true;
				break;
			} else {
				break;
			}

		}
	}
	return isBigger;
}

export const compareFirmware = (first, second) => {
	let isBigger = 0;
	if (first !== "" && second === "")
		return 1;
	else if (first === "" && second !== "")
		return -1
	else if (first === "" && second === "")
		return 0;

	const firstData = first.split(".");
	const secondData = second.split(".");

	for (let index = 0; index < firstData.length - 1; index++) {
		if (firstData[index] !== secondData[index]) {
			if (firstData[index] > secondData[index]) {
				isBigger = 1;
				break;
			} else {
				isBigger = -1;
				break;
			}

		}
	}
	return isBigger;
}

export const getDevicesTypeSearch = (messages) => {

	const typeOptions = [
		{
			id: "",
			label: messages['devices_main_all']
		},
		{
			id: "esn",
			label: messages['devices_main_esn']
		},
		{
			id: "imei",
			label: messages['devices_main_imei']
		},
		{
			id: "simCard_iccId",
			label: messages['devices_main_iccid']
		},
		{
			id: "company_name",
			label: messages['devices_main_company']
		},
		{
			id: "label",
			label: messages['devices_main_label']
		},
		{
			id: "reference",
			label: messages['devices_main_reference']
		},
		{
			id: "vehicleInformation_vin",
			label: messages['devices_main_vin']
		},
		{
			id: "simCard_msisdn",
			label: messages['devices_main_phone_number']
		},
		{
			id: "unitConfig_billingAccount_name",
			label: messages['devices_main_billing_account']
		}
	]

	return typeOptions;
}

export const processGadgetData = (type, data, chartData, messages, settings) => {
	let result = {}
	let labels = []
	switch (type) {
		case "VidFleetFirmware":
			labels = data.map((item) => item.firmwareId || "NA")
			result = {
				labels,
				data: [chartData?.qtty],
				datasets: [{
					data: data.map(item => item.qtty),
					backgroundColor: backgroundColor,
					hoverOffset: 4
				}],
				type,
				unit: 'Total',
				subTitle: `${messages['dashboard_device_model']} ${chartData?.deviceModel}`,
				legend: false
			};
			break;
		case "UnitsThatStoppedReporting":
			const { initAge, interval } = settings
			let totals = data[0]?.totals ? JSON.parse(data[0].totals) : 0
			labels = [
				`${initAge} - ${initAge + interval} ${messages['dashboardPanel_edit_days']}`,
				`${(initAge + interval) + 1} - ${(initAge + interval * 2)} ${messages['dashboardPanel_edit_days']}`,
				`${(initAge + interval * 2) + 1} - ${(initAge + interval * 3)} ${messages['dashboardPanel_edit_days']}`,
				`+${(initAge + interval * 3) + 1} ${messages['dashboardPanel_edit_days']}`]
			result = {
				labels,
				datasets: [
					{
						label: [messages['account_overview_devices']],
						backgroundColor: backgroundColor,
						data: totals,
					},
				],
				requestLimit: (initAge + interval * 4) + 180
			};
			break;

		default:
			break;
	}

	return result
}
export const getEpochConstant = () => {
	return "946702800000"; //2000-01-01
}

export const parseNumberAndUnit = (inputString) => {
	let regex = /([-+]?\d+)\s*(?:-\s*([-+]?\d+)\s*)?([a-zA-Z]+)/;
	let matches = inputString.match(regex);
	if (matches) {
		const startNumber = parseInt(matches[1]);
		const endNumber = matches[2] ? parseInt(matches[2]) : null;
		return {
			startNumber,
			endNumber
		};
	} else {
		regex = /(\d+)/;
		matches = inputString.match(regex);
		if (matches && matches.length > 1) {
			const startNumber = parseInt(matches[1]);
			return {
				startNumber
			};
		}
	}
}

export const getEventColor = (events, eventName) => {
	let color = "#000000"
	let event = events.find(x => x.name === eventName)
	color = event?.color || "#000000"

	return color
}

export const getVidFleetConfigValues = () => {
	return {

		dms: {
			minSpeed: {
				USING_PHONE: { default: 40, max: 200, min: 0 },
				DROWSINESS: { default: 40, max: 200, min: 0 },
				DAYDREAMING: { default: 40, max: 200, min: 0 },
				DISTRACTED: { default: 40, max: 200, min: 40 },
				ATTENTIVE: { default: 0, max: 200, min: 0 },
				NO_SEATBELT: { default: 40, max: 200, min: 8 },
				YAWN: { default: 40, max: 200, min: 40 },
				SMOKING: { default: 40, max: 200, min: 0 },
				ASLEEP: { default: 40, max: 200, min: 0 },
				NO_DRIVER: { default: 8, max: 200, min: 8 },
				IDLE_NO_DRIVER: { default: 0, max: 200, min: 0 }
			},
			detectionDelay: {
				USING_PHONE: { default: 50, max: 4000, min: 20 },
				DROWSINESS: { default: 5, max: 4000, min: 5 },
				DAYDREAMING: { default: 10, max: 4000, min: 5 },
				DISTRACTED: { default: 40, max: 4000, min: 20 },
				ATTENTIVE: { default: 5, max: 4000, min: 5 },
				NO_SEATBELT: { default: 200, max: 4000, min: 50 },
				YAWN: { default: 5, max: 4000, min: 5 },
				SMOKING: { default: 10, max: 4000, min: 5 },
				ASLEEP: { default: 4, max: 4000, min: 5 },
				NO_DRIVER: { default: 600, max: 4000, min: 300 },
				IDLE_NO_DRIVER: { default: 1800, max: 4000, min: 1200 }
			},
			repeatInterval: {
				USING_PHONE: { default: 6000, max: 12000, min: 6000 },
				DROWSINESS: { default: 1200, max: 12000, min: 1200 },
				DAYDREAMING: { default: 6000, max: 12000, min: 6000 },
				DISTRACTED: { default: 3000, max: 12000, min: 3000 },
				ATTENTIVE: { default: 6000, max: 12000, min: 6000 },
				NO_SEATBELT: { default: 6000, max: 12000, min: 6000 },
				YAWN: { default: 300, max: 12000, min: 3000 },
				SMOKING: { default: 6000, max: 12000, min: 6000 },
				ASLEEP: { default: 1200, max: 12000, min: 1200 },
				NO_DRIVER: { default: 6000, max: 12000, min: 6000 },
				IDLE_NO_DRIVER: { default: 6000, max: 12000, min: 6000 }
			},
			detectionReset: {
				USING_PHONE: { default: 10, max: 200, min: 10 },
				DROWSINESS: { default: 0, max: 200, min: 0 },
				DAYDREAMING: { default: 0, max: 200, min: 0 },
				DISTRACTED: { default: 10, max: 200, min: 10 },
				ATTENTIVE: { default: 0, max: 200, min: 0 },
				NO_SEATBELT: { default: 5, max: 200, min: 5 },
				YAWN: { default: 20, max: 200, min: 20 },
				SMOKING: { default: 0, max: 200, min: 0 },
				ASLEEP: { default: 0, max: 200, min: 0 },
				NO_DRIVER: { default: 0, max: 200, min: 0 },
				IDLE_NO_DRIVER: { default: 10, max: 200, min: 10 }
			}
		},
		advanced: {
			adas: {
				minSpeed: {
					FORWARD_COLLISION_WARNING: { default: 0, max: 200, min: 0 },
					HEADWAY_MONITORING_WARNING: { default: 65, max: 200, min: 65 },
					HEADWAY_MONITORING_EMERGENCY: { default: 65, max: 200, min: 65 },
					LANE_DEPARTURE_WARNING: { default: 50, max: 200, min: 50 },
					STOP_SIGN_VIOLATION: { default: 10, max: 200, min: 8 }
				},
				detectionDelay: {
					FORWARD_COLLISION_WARNING: { default: 5, max: 200, min: 5 },
					HEADWAY_MONITORING_WARNING: { default: 5, max: 200, min: 5 },
					HEADWAY_MONITORING_EMERGENCY: { default: 30, max: 200, min: 30 },
					LANE_DEPARTURE_WARNING: { default: 20, max: 200, min: 20 },
					STOP_SIGN_VIOLATION: { default: 10, max: 200, min: 10 }
				},
				repeatInterval: {
					FORWARD_COLLISION_WARNING: { default: 3000, max: 12000, min: 3000 },
					HEADWAY_MONITORING_WARNING: { default: 3000, max: 12000, min: 3000 },
					HEADWAY_MONITORING_EMERGENCY: { default: 3000, max: 12000, min: 3000 },
					LANE_DEPARTURE_WARNING: { default: 1200, max: 12000, min: 1200 },
					STOP_SIGN_VIOLATION: { default: 1200, max: 12000, min: 1200 }
				},
				detectionReset: {
					FORWARD_COLLISION_WARNING: { default: 5, max: 200, min: 5 },
					HEADWAY_MONITORING_WARNING: { default: 10, max: 200, min: 10 },
					HEADWAY_MONITORING_EMERGENCY: { default: 10, max: 200, min: 10 },
					LANE_DEPARTURE_WARNING: { default: 10, max: 200, min: 10 },
					STOP_SIGN_VIOLATION: { default: 10, max: 200, min: 10 }
				}
			},
			safetyAssistance: {
				alarm: {
					NO_SEATBELT: {
						enable: true,
						default: 7,
						max: 30,
						min: 5
					},
					DISTRACTED: {
						enable: true,
						default: 5,
						max: 30,
						min: 2
					},
					CLOSE_FOLLOWING: {
						enable: false,
						default: 1,
						max: 30,
						min: 1
					},
					LANE_DEPARTURE: {
						enable: true,
						default: 4,
						max: 30,
						min: 2
					},
					USING_CELLPHONE: {
						enable: true,
						default: 7,
						max: 30,
						min: 3
					},
					NO_DRIVER: {
						enable: true,
						default: 10,
						max: 30,
						min: 50
					},
					TAILGATING: {
						enable: true,
						default: 60,
						max: 200,
						min: 50
					},
					SPEEDING: {
						enable: false,
						default: 50,
						max: 200,
						min: 30
					},
					PASSENGERS_NO_SEATBELT: {
						enable: false,
						default: 50,
						max: 200,
						min: 30
					},
					OVER_MAX_SPEED: {
						enable: false,
						default: 50,
						max: 200,
						min: 30
					},
					PEDESTRIAN: {
						enable: false,
						default: 50,
						max: 200,
						min: 30
					},
					CYCLIST: {
						enable: false,
						default: 50,
						max: 200,
						min: 30
					},
					count: {
						min: 1,
						max: 10,
						default: 5
					}
				}
			},
			nav: {
				maxSpeed: {
					OVER_MAX_SPEED: { default: 120, max: 200, min: 8 }
				},
				minSpeed: {
					SPEEDING: { default: 40, max: 200, min: 40 },
					OVER_MAX_SPEED: { default: 40, max: 200, min: 40 }
				},
				detectionDelay: {
					SPEEDING: { default: 100, max: 200, min: 8 },
					OVER_MAX_SPEED: { default: 50, max: 200, min: 8 }
				},
				repeatInterval: {
					SPEEDING: { default: 600, max: 12000, min: 8 },
					OVER_MAX_SPEED: { default: 600, max: 12000, min: 8 }
				},
				detectionReset: {
					SPEEDING: { default: 10, max: 200, min: 8 },
					OVER_MAX_SPEED: { default: 10, max: 200, min: 8 }
				},
				overspeedLimit: {
					SPEEDING: { default: 10, max: 200, min: 1 },
					OVER_MAX_SPEED: { default: 0, max: 200, min: 0 }
				}
			}
		}
	}
}

export const getDateRange = (time) => {
	let startDate = null
	let endDate = null
	switch (time) {
		case 'quarter':
			startDate = moment().startOf('quarter').toDate()
			endDate = moment.max(moment()).endOf('day').toDate()
			break;
		case 'today':
			startDate = moment().startOf('day').toDate()
			break;
		case 'yesterday':
			startDate = moment().subtract(1, 'days').startOf('day').toDate()
			break;
		case 'thisweek':
			startDate = moment().startOf('week').toDate()
			endDate = moment.max(moment()).endOf('day').toDate()
			break;
		case 'lastweek':
			startDate = moment().startOf('week').subtract(1, 'weeks').toDate()
			endDate = moment(startDate).add(1, 'week').endOf('day').toDate()
			break;
		case 'thismonth':
			startDate = moment().startOf('month').toDate()
			endDate = moment.max(moment()).endOf('day').toDate()
			break;
		case 'lastmonth':
			startDate = moment(moment()).subtract(1, 'months').startOf('month').toDate()
			endDate = moment(moment()).subtract(1, 'months').endOf('month').toDate()
			break;
		case 'thisquarter':
			startDate = moment().startOf('quarter').toDate()
			endDate = moment.max(moment()).endOf('day').toDate()
			break;
		case 'lastquarter':
			startDate = moment().quarter(moment().quarter() - 1).startOf('quarter').toDate()
			endDate = moment().quarter(moment().quarter() - 1).endOf('quarter').toDate()
			break;
		case 'thisyear':
			startDate = moment().startOf('year').toDate()
			endDate = moment.max(moment()).endOf('day').toDate()
			break;
		case 'lastyear':
			startDate = moment().subtract(1, 'years').startOf('year').toDate()
			endDate = moment().subtract(1, 'years').endOf('year').toDate()
			break;
		case 'last7days':
			startDate = moment().subtract(7, 'days').startOf('day').toDate()
			endDate = moment.max(moment()).endOf('day').toDate()
			break;
		case 'last15days':
			startDate = moment().subtract(15, 'days').startOf('day').toDate()
			endDate = moment.max(moment()).endOf('day').toDate()
			break;
		case 'last30days':
			startDate = moment().subtract(30, 'days').startOf('day').toDate()
			endDate = moment.max(moment()).endOf('day').toDate()
			break;
	}
	return {
		startDate,
		endDate
	}
}

export const getTransactionsProcessingStatusColor = (status) => {
	let statusColors = {
		PENDING: { color: "#00AAFB", label: "transactions_details_pending" },
		Pending: { color: "#00AAFB", label: "transactions_details_pending" },
		InProgress: { color: "#31B522 ", label: "transactions_details_in_progress" },
		SUCCESS: { color: "#00A674", label: "transactions_details_processed" },
		Processed: { color: "#00A674", label: "transactions_details_processed" },
		FAILURE: { color: "#F50E02", label: "transactions_details_failure" },
		Failure: { color: "#F50E02", label: "transactions_details_failure" },
		Void: { color: "#5A5A5A", label: "transactions_details_void" },
		Unsubscribed: { color: "#5A5A5A", label: "transactions_details_unsubscribed" },
		Delivered: { color: "#66BB6A", label: "transactions_details_delivered" }
	}

	return statusColors[status]
}

export const getTransactionsTypesOptions = (messages) => {
	const statusOptions = [
		{
			id: "ScriptCalampDevices",
			label: messages["transactions_requests_script_calamp_devices"]
		},
		{
			id: "CreateQueclinkDevices",
			label: messages["transactions_requests_create_queclink_devices"]
		},
		{
			id: "ImportUnits",
			label: messages["transactions_requests_import_units"]
		},
		{
			id: "VidFleetRebootDevices",
			label: messages["transactions_requests_vidFleet_reboot_devices"]
		},
		{
			id: "ReprocessOdoHrs",
			values: ["ReprocessOdoHrs", "RecalculateOdometerHours"],
			label: messages["transactions_requests_reprocess_odo_hrs"]
		},
		{
			id: "DiagnosticUnits",
			label: messages["transactions_requests_diagnostic_units"]
		},
		{
			id: "Resync",
			label: messages["transactions_requests_resync"]
		}

	]

	return statusOptions;
}

export const getProcessingStatusOptions = (messages) => {
	const statusOptions = [
		{
			id: "Pending",
			label: messages["transactions_details_pending"]
		},
		{
			id: "InProgress",
			label: messages["transactions_details_in_progress"]
		},
		{
			id: "Processed",
			label: messages["transactions_details_processed"]
		},
		{
			id: "Failure",
			label: messages["transactions_details_failure"]
		},
		{
			id: "Void",
			label: messages["transactions_details_void"]
		},
		{
			id: "Unsubscribed",
			label: messages["transactions_details_unsubscribed"]
		},
		{
			id: "Delivered",
			label: messages["transactions_details_delivered"]
		}

	]

	return statusOptions;
}

export const getHDopColorLabel = (hdopRaw, messages) => {
	let hdop = hdopRaw > 0 ? hdopRaw / 100 : 0;
	if (hdop < 1) {
		return { color: "#008000", label: messages['system_alert_logs_tab_hdop_ideal'], value: hdop };
	} else if (hdop >= 1 && hdop < 2) {
		return { color: "#90EE90", label: messages['system_alert_logs_tab_hdop_excellent'], value: hdop };
	} else if (hdop >= 2 && hdop < 5) {
		return { color: "#6EAA5E", label: messages['system_alert_logs_tab_hdop_good'], value: hdop };
	} else if (hdop >= 5 && hdop < 10) {
		return { color: "#FFFF00", label: messages['system_alert_logs_tab_hdop_moderate'], value: hdop };
	} else if (hdop >= 10 && hdop < 20) {
		return { color: "#FF5232", label: messages['system_alert_logs_tab_hdop_fair'], value: hdop };
	} else if (hdop >= 20) {
		return { color: "#FF0000", label: messages['system_alert_logs_tab_hdop_poor'], value: hdop };
	}
}

export const getRssiSignalIcon = (rssi, messages) => {
	let signal = { label: messages['system_alert_logs_tab_hdop_unknown'], icon: Unknown };
	if (rssi > -79) {
		signal = { label: `${messages['system_alert_logs_tab_hdop_excellent']} (${rssi})`, icon: Excellent };
	} else if (rssi <= -80 && rssi >= -89) {
		signal = { label: `${messages['system_alert_logs_tab_hdop_good']} (${rssi})`, icon: Good };
	} else if (rssi <= -90 && rssi >= -100) {
		signal = { label: `${messages['system_alert_logs_tab_hdop_fair']} (${rssi})`, icon: Fair };
	} else if (rssi <= -100 && rssi >= -109) {
		signal = { label: `${messages['system_alert_logs_tab_hdop_poor']} (${rssi})`, icon: Poor };
	} else if (rssi < -111) {
		signal = { label: `${messages['system_alert_logs_tab_hdop_no_signal']} (${rssi})`, icon: Unknown };
	}
	return <img src={signal.icon} title={signal.label} alt={signal.label} />
}

export const getCerebrumXPackages = (messages) => {
	return [
		{ id: "PREMIUM", name: messages['package_premium'] },
		{ id: "ADVANCED", name: messages['package_advanced'] },
		{ id: "BASIC", name: messages['package_basic'] }
	]
}

export const getCerebrumXStatus = (status, messages) => {
	let formatedStatus = {}

	switch (status) {
		case "PENDING":
		case "Pending":
			formatedStatus = { id: "Pending", name: messages['pending'], backgroundColor: "#F5A623" }
			break;
		case "ACTIVE":
		case "Active":
			formatedStatus = { id: "Active", name: messages['active'], backgroundColor: "#66BB6A" }
			break;
		case "ACCEPTED":
		case "Accepted":
			formatedStatus = { id: "Accepted", name: messages['accepted'], backgroundColor: "#66BB6A" }
			break;
		case "REJECTED":
		case "Rejected":
			formatedStatus = { id: "Rejected", name: messages['rejected'], backgroundColor: "red" }
			break;
		default:
			formatedStatus = { id: status, name: status, backgroundColor: "lightgray" }
			break;
	}

	return formatedStatus
}

export const getCerebrumXParameters = (item, messages) => {
	let parameters = item?.parameters
	if (parameters?.oems?.length > 0) {
		let oems = parameters?.oems
		if (oems?.length > 0) {
			return (
				<div style={{ display: 'flex', flexWrap: 'wrap' }}>
					{
						oems.map((oem, key) => {
							let chip = getCerebrumXStatus(oem.consentStatus, messages)
							return <div style={{ marginLeft: 5 }}>
								<Tooltip title={messages[oem.consentStatus.toLowerCase()] || oem.consentStatus}>
									<Chip
										label={oem.name}
										size="medium"
										style={{
											backgroundColor: chip.backgroundColor,
											color: "#ffffff"
										}} />
								</Tooltip>
							</div>
						})
					}
				</div>
			)
		}
	}
}

export const getCerebrumXOEMs = () => {
	return [
		"FORDPRO",
		"GM",
		"STELLANTIS",
		"TESLA",
		"TOYOTA"
	]
}

export const secondsToHours = (seconds) => {
	if (!seconds) return 0
	const hours = seconds / 3600;
	return hours;
}

export const getWarningCategory = (isSdCardError, warnings, isOffline, messages) => {
	let title = '';
	let color = '';
	if (isSdCardError) {
		title = messages['devices_main_sd_card_error'];
		color = '#F44336';
	} else if (warnings) {
		title = `${messages['devices_main_maintenance_warnings']}: ${warnings}`;
		color = '#FF6624';
	} else if (isOffline) {
		title = messages['devices_main_offline'];
		color = '#FFDC00';
	}

	return {
		title,
		color
	}
}

export const getMonths = (messages) => {
	return [
		messages["month_jan"],
		messages["month_feb"],
		messages["month_mar"],
		messages["month_apr"],
		messages["month_may"],
		messages["month_jun"],
		messages["month_jul"],
		messages["month_aug"],
		messages["month_sep"],
		messages["month_oct"],
		messages["month_nov"],
		messages["month_dec"]
	]
}

export const validateEpochDate = (epoch) => {

	if (typeof epoch !== "number" || isNaN(epoch)) {
		return true
	}

	const minDate = "2000-01-01T00:00:00Z";
	const minEpoch = new Date(minDate).getTime();
	const epochMs = epoch * 1000;
	return epochMs >= minEpoch;
}

const filterItems = (items, includeDefault) => {
	const defaultItem = items.find(item => item.isDefault);
	if (!defaultItem) return [];
	if (!includeDefault) {
		return [defaultItem];
	} else {
		return items.filter(item => item.id >= defaultItem.id);
	}
}

export const groupByHardwareVersion = (array, firmwareList, assignLastFirmwares, assignBetaFirmwares) => {
	const result = {};
	const agrupados = array.reduce((acc, item) => {
		const key = item.unitConfig.hardwareVersion;
		if (!acc[key]) {
			acc[key] = [];
		}
		acc[key].push(item);
		return acc;
	}, {});

	let hardwareVersionGroups = Object.keys(agrupados);
	hardwareVersionGroups.forEach(hardwareVersion => {
		//console.log("group", agrupados[hardwareVersion])
		let devices = agrupados[hardwareVersion];
		let firmwares = firmwareList?.length ? firmwareList.filter((item) => item?.hardwareVersion === hardwareVersion && item.isActive).map((item) => ({ ...item, label: `${item?.version} - ${item?.build}${item?.isDefault ? " - Default" : ""}` })) : []
		let fwDefault = firmwares?.find(x => x.isActive && x.isDefault);
		let newfws = [];
		let fws = [];

		//add the default firmware
		if (fwDefault) {
			fws = [fwDefault];
		}

		//new Firmwares
		newfws = firmwares.filter(x =>
			toInteger(x?.firmwareId) > toInteger(fwDefault?.firmwareId)
		);

		//verify permissions and combine firmwares
		if (assignLastFirmwares) {
			firmwares = [...newfws, ...fws];
		} else {
			firmwares = [...fws];
		}
		// permissions to apply beta firmwares
		if (!assignBetaFirmwares) {
			firmwares = firmwares.filter(x => x?.build !== "BETA");
		}

		// Sort firmwares by firmwareId
		if (firmwares?.length) {
			firmwares = Object.values(firmwares).sort((a, b) => {
				if (toInteger(a.firmwareId) < toInteger(b.firmwareId)) return -1;
				if (toInteger(a.firmwareId) > toInteger(b.firmwareId)) return 1;
				return 0;
			});
		}
		let items = []
		// filter devices that does not have a firmwareId or have a firmwareId that is less than the latest firmwareId available
		for (let i = 0; i < devices.length; i++) {
			const item = devices[i];
			const firmwareId = item?.unitConfig?.firmwareId || "";

			let currentVersion = firmwares?.find(x => x?.version === firmwareId)
			if (!currentVersion || (currentVersion && firmwares.find(x => toInteger(x.firmwareId) > toInteger(currentVersion.firmwareId)))) {
				// If there is a new firmware greater than the current firmware, set it as newFirmware
				items.push(item);
			}
		}

		result[hardwareVersion] = { hardwareVersion, deviceModel: items?.[0]?.deviceModel?.name, firmwares, newFirmware: null, items: items };
	})

	// Convert the result object into an array of groups and sort by hardwareVersion
	return Object.values(result).sort((a, b) => {
		if (a.hardwareVersion < b.hardwareVersion) return -1;
		if (a.hardwareVersion > b.hardwareVersion) return 1;
		return 0;
	});
}
export const getDataForEntityTags = (entity, accounts, units, subusers, forms, landmarks, geofences) => {
	let data = [];
	if (entity === "Company") {
		data = accounts.map(d => {
			return { id: d.id, name: "Company", label: d.name }
		});
	} else if (entity === "Unit") {
		data = units.map(d => {
			return { id: d.id, name: "Unit", label: d.label }
		});
	} else if (entity === "User") {
		data = subusers?.items?.map(d => {
			return { id: `${d.id}`, name: "User", label: d.userName }
		});
	} else if (entity === "Form") {
		data = forms?.map(f => {
			return { id: `${f.id}`, name: "Form", label: f.name }
		});
	} else if (entity === "Landmark") {
		data = landmarks?.map(d => {
			return { id: d.id, name: "Landmark", label: d.name }
		});
	} else if (entity === "Geofence") {
		data = geofences?.map(g => {
			return { id: g.id, name: "Geofence", label: g.name }
		});
	}
	return data;
}

export const getTagColor = (color) => {
	if (!color) return "000000";

	let notAvailableColors = [
		'white',
		'fff',
		'ffffff'
	];

	let newColor = color?.toLowerCase();
	if (notAvailableColors?.includes(newColor)) {
		return "000000";
	}

	return color;
}

export const getMessageTemplateCodes = (messages) => {
	let codes = [
		{ id: "verifyEmail", label: messages['message_template_code_verify_email'] },
		{ id: "forgotPassword", label: messages['message_template_code_forgot_password'] },
		{ id: "verifyEmailLegacy", label: messages['message_template_code_verify_email_legacy'] }
	]

	return codes;
}

export const languageOptions = (messages) => {
	let languages = [
		{ id: "en", name: messages['english_label'] },
		{ id: "es", name: messages['spanish_label'] }
	]
	return languages;
}

export const getTemplatesFields = (messages) => {
	let templateFields = {}

	templateFields['verifyEmail'] = [
		{ id: "name", name: messages['messages_templates_name'] },
		{ id: "username", name: messages['messages_templates_username'] },
		{ id: "link", name: messages['messages_templates_link'] }
	]
	templateFields['forgotPassword'] = [
		{ id: "name", name: messages['messages_templates_name'] },
		{ id: "link", name: messages['messages_templates_link'] }
	]
	templateFields['verifyEmailLegacy'] = [
		{ id: "code", name: messages['messages_templates_code'] },
	]

	return templateFields;
}

export const getEdgeTensorStatusOptions = (messages) => {
	const statusOptions = [
		{
			id: "Confirm",
			label: messages["edge_tensor_tab_confirm"]
		},
		{
			id: "Unknown",
			label: messages["edge_tensor_tab_unknown"]
		},
		{
			id: "FalsePositive",
			label: messages["edge_tensor_tab_false_positive"]
		},
		{
			id: "Unreviewed",
			label: messages["edge_tensor_tab_unreviewed"]
		}
	]

	return statusOptions;
}

export const getVideoReviewStatusOptions = (messages) => {
	const statusOptions = [
		{
			id: "Unreviewed",
			label: messages["edge_tensor_video_review_unreviewed"]
		},
		{
			id: "Reviewed",
			label: messages["edge_tensor_video_review_reviewed"]
		},
		{
			id: "FalsePositive",
			label: messages["edge_tensor_video_review_false_positive"]
		},
		{
			id: "Accepted",
			label: messages["edge_tensor_video_review_accepted"]
		},
		{
			id: "Disputed",
			label: messages["edge_tensor_video_review_disputed"]
		}
	]

	return statusOptions;
}


export const getDateRangeOptions = (messages) => {
	const typeOptions = [
		{
			id: "ReviewDate",
			label: messages['report_overview_review_date']
		},
		{
			id: "EventDate",
			label: messages['report_overview_event_date']
		}
	]
	return typeOptions;
}

export const download = (url, name, callback) => {
	if (url) {
		axios({
			url: url,
			method: 'GET',
			responseType: 'blob',
		}).then((response) => {
			const urlObject = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = urlObject;
			link.setAttribute('download', name);
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			if (callback) callback();
		});
	}
};

export const getEventsTypes = (messages) => {
	const eventTypes = OrderData([
		{ name: messages['video_event_type_asleep'], id: "Asleep" },
		{ name: messages['video_event_type_drivingHit'], id: "Sudden Stop" },
		{ name: messages['video_event_type_dayDreaming'], id: "Day Dreaming" },
		{ name: messages['video_event_type_distracted'], id: "Distracted" },
		{ name: messages['video_event_type_drowsy'], id: "Drowsiness" },
		{ name: messages['video_event_type_hardAccel'], id: "Rapid Acceleration" },
		{ name: messages['video_event_type_hardBrake'], id: "Hard Brake" },
		{ name: messages['video_event_type_sharpTurn'], id: "Hard Turn" },
		{ name: messages['video_event_type_manual'], id: "Manual" },
		{ name: messages['video_event_type_noSeatBelt'], id: "No Seatbelt" },
		{ name: messages['video_event_type_smoking'], id: "Smoking" },
		{ name: messages['video_event_type_usingPhone'], id: "Using Phone" },
		{ name: messages['video_event_type_yawn'], id: "Yawn" },
		{ name: messages['video_event_type_collisionWarning'], id: "Collision Warning" },
		{ name: messages['video_event_type_laneDeparture'], id: "Lane Departure" },
		{ name: messages['video_event_type_closeFollowing'], id: "Close Following" },
		{ name: messages['video_event_type_tailgating'], id: "Tailgating" },
		{ name: messages['video_event_type_stopSignViolation'], id: "Stop Sign Violation" },
		{ name: messages['video_event_type_noDriver'], id: "Camera Obstructed" },
		{ name: messages['video_event_type_idleNoDriver'], id: "Idle No Driver" },
		{ name: messages['video_event_type_potentialIncident'], id: "Potential Incident" },
		{ name: messages['video_event_type_passengerInside'], id: "Passenger Inside" },
		{ name: messages['video_event_type_potentialIncidentMedium'], id: "Potential Incident Medium" },
	], 'name');

	return eventTypes;
}

export const getImportAccountStatusOptions = (messages) => {
	const statusOptions = [
		{
			id: "Pending",
			label: messages["common_pending"]
		},
		{
			id: "InProgress",
			label: messages["common_in_progress"]
		},
		{
			id: "Done",
			label: messages["common_done"]
		},
		{
			id: "DoneWithErrors",
			label: messages["common_done_with_errors"]
		},
		{
			id: "Failed",
			label: messages["common_failed"]
		}
	];
	return statusOptions;
}

export const getHardwareVersionOptions = () => {
	const HARDWARE_OPTIONS = [
		{
			id: 'NEXTER_V5B',
			label: 'NEXTER_V5B'
		},
		{
			id: 'NEXTER_V5C',
			label: 'NEXTER_V5C'
		},
		{
			id: 'NEXTER_V5D',
			label: 'NEXTER_V5D'
		},
		{
			id: 'SAXHORN_V0C',
			label: 'SAXHORN_V0C'
		},
		{
			id: 'SAXHORN_V1C',
			label: 'SAXHORN_V1C'
		},
		{
			id: 'SC_V1H',
			label: 'SC_V1H'
		},
		{
			id: 'SC_V2H',
			label: 'SC_V2H'
		},
		{
			id: 'SC_V1S',
			label: 'SC_V1S'
		}
	];
	return HARDWARE_OPTIONS;
}